import { useEffect } from 'react';

export const useAddToHomeScreen = (): void => {
  useEffect(() => {
    const handler = async (e: Event): Promise<void> => {
      e.preventDefault();

      /*
      For now we just prevent automatic prompting

      const deferredPrompt = e;

      deferredPrompt.prompt();
      const choice = await deferredPrompt.userChoice;

      if (choice.outcome === 'accepted') {
        console.log('User accepted the A2HS prompt');
      } else {
        console.log('User dismissed the A2HS prompt');
      }
      */
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);
};
